import React, {useState} from "react";
import Button from '@mui/material/Button';
import CardGrid from "../atoms/Grid/CardGrid";
import Card from "../atoms/Cards/Card";
import GetAppIcon from '@mui/icons-material/GetApp';
import CloseIcon from '@mui/icons-material/Close';
import {CustomerDates, CustomerDetails, MarkerComponent as Marker} from "./CustomerDetails";
import DeleteDialog from "../molcules/Dialogs/DeleteDialog";
import { styled } from '@mui/material/styles';

const SHARED_EMAIL_BORDER_COLORS = [
  '#2E7D32',
  '#1976D2',
  '#7B1FA2',
  '#D32F2F',
  '#F57C00',
  '#00838F',
  '#5D4037',
  '#455A64',
  '#C2185B',
  '#6D4C41'
];

const getSharedEmailBorderColor = (sharedEmail) => {
  if (!sharedEmail) {
    return null;
  }

  const value = String(sharedEmail);
  let hash = 0;
  for (let i = 0; i < value.length; i += 1) {
    hash = ((hash << 5) - hash) + value.charCodeAt(i);
    hash |= 0;
  }

  return SHARED_EMAIL_BORDER_COLORS[Math.abs(hash) % SHARED_EMAIL_BORDER_COLORS.length];
};

const CustomerProperty = ({property, value}) => <div style={{
  fontSize:14,
  display:'flex',
  alignItems: 'center',
  gap:6,
  marginBottomn:6
}}><div style={{width:66}}>{property}</div><b>{value}</b></div>

const DeleteIcon = styled(CloseIcon)({
  transform: 'scale(0.9)',
  color: 'red',
  position: 'absolute',
  top: 3,
  right: 3,
  zIndex: 10,
  opacity: 0,
  transition: 'opacity 0.2s ease-in-out',
});

const CustomerCard = styled('div')({
  position: 'relative',
  '&:hover': {
    '& .delete-icon': {
      opacity: 1,
    }
  }
});


const Customer = ({customer}) => {
  return (
    <div>
      <div>
        <div style={{
          paddingBottom:6,
          fontSize:15,
          fontWeight: 'bold',
          display:'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          gap:6
        }}><span style={{display: 'inline', whiteSpace: 'break-spaces'}}>{customer.firstName} {customer.lastName}{customer.sharedEmail ? <span style={{color: getSharedEmailBorderColor(customer.sharedEmail), opacity: 0.7, textTransform: 'uppercase', fontSize: 11}}> | {customer.sharedEmail}</span> : ''} </span> {customer.present && <Marker label={'Checked In'} />}</div>
        <CustomerDates customer={customer}/>
        <CustomerProperty property={'Room'} value={customer.space || 'Day Guest'} />
        <CustomerProperty property={'Type'} value={customer.customerType || '-'} />
        <CustomerProperty property={'Profile'} value={customer.hasProfile ? 'Yes' : 'No'} />
      </div>
    </div>
  );
}

const CustomerActions = ({exportCustomerCSV = () => {}}) => {
  return <div style={{
    display: 'flex',
    justifyContent: 'end',
    marginBottom: 16
  }}>
    <Button
      variant={'outlined'}
      startIcon={<GetAppIcon />}
      color={'primary'}
      onClick={exportCustomerCSV} >Export
    </Button>
  </div>
}

export const CustomerList = ({customers = [], exportCustomerCSV, onDelete}) => {
  const [open, setOpen] = useState(false);
  const [selectedCustomer, setSelectedCustomer] = useState(false);
  const [showDelete, setShowDelete] = useState(false);
  const [deleteTarget, setDeleteTarget] = useState(null);

  const handleDelete = (e, customer) => {
    e.stopPropagation();
    setDeleteTarget(customer);
    setShowDelete(true);
  };

  const confirmDelete = () => {
    if (deleteTarget && onDelete) {
      onDelete(deleteTarget);
    }
    setShowDelete(false);
    setDeleteTarget(null);
  };

  return (
    <div>
      <CustomerDetails customer={selectedCustomer} open={open} onClose={() => setOpen(false)}/>
      {onDelete && <DeleteDialog
        heading={'Are you sure you want to delete this submission?'}
        show={showDelete}
        onDelete={confirmDelete}
        onClose={() => setShowDelete(false)}
      />}
      {exportCustomerCSV && <CustomerActions exportCustomerCSV={exportCustomerCSV}/>}
      <CardGrid>
      {customers.map((customer, index) => (
        <div key={index} style={{cursor: 'pointer'}} onClick={()=>{
          setSelectedCustomer(customer);
          setOpen(true);
        }}><Card style={{
          background: customer.hasProfile ? '#e6f4e7' : 'default',
          border: customer.sharedEmail ? `1px solid ${getSharedEmailBorderColor(customer.sharedEmail)}` : undefined
        }}>
          <CustomerCard>
            {onDelete && <DeleteIcon className="delete-icon" fontSize={'small'} onClick={(e) => handleDelete(e, customer)} />}
            <Customer customer={customer} />
          </CustomerCard>
        </Card></div>
      ))}
      </CardGrid>
      {customers && customers.length === 0 && <p>No guests found.</p>}

    </div>
  )
};
